import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import VueWechatTitle from 'vue-wechat-title'
import VueClipboard from 'vue-clipboard2'

import 'element-ui/lib/theme-chalk/index.css'
import 'styles/base/base.css'
import 'assets/icons/iconfont.css'

Vue.use(VueWechatTitle)
Vue.config.productionTip = false
Vue.prototype.$url = 'http://yuanda.fxb-dc.cn'
Vue.use(ElementUI)
Vue.use(VueClipboard)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
